export default {
  common: {
    done: 'Hecho',
    term: 'Término',
    year: 'Año | Años',
    years: 'Años',
    yr: '/año',
    month: 'Mes | Meses',
    quantity: 'Cantidad',
    add: 'Añadir',
    loading: 'Cargando',
    error: "Corrija los errores o <a  class='link-info'>elimine</a> el artículo de su carrito.",
    domain: 'Dominio',
    edit: 'Editar',
    account: 'Cuenta',
    accounts: 'Cuentas',
    zone: 'Zona',
    zones: 'Zonas',
    relay: 'Transmisión',
    relays: 'Transmisiones',
    enter_domain: 'Ingrese un dominio',
    hostnames: 'Nombre de Host',
    term_callout: '¿Necesita una duración más larga?',
    select_term: 'Seleccione su término',
    recommended: 'Recomendado',
    save: 'Ahorrar',
    includes: 'Incluye',
    adjusting_preview: 'Ajuste de vista previa',
    coupon_code_is_not_valid: 'El código de cupón no es válido.',
    contact_support_if_you_believe_this_is_an_error: 'Póngase en contacto con el soporte si cree que se trata de un error.',
    coupon_applied: 'Cupón aplicado',
    sub_total: 'Subtotal',
    available_credit: 'Crédito disponible',
    credit_used: 'Crédito utilizado',
    coupon_code_will_be_applied_once_logged_in: 'El código de cupón se aplicará una vez que haya iniciado sesión.',
    monthly: 'Mensual',
    annually: 'Anualmente'
  },
  errors: {
    invalid_domain: 'NOPE'
  },
  topnav: {
    planbuilder: 'Editor de planes',
    payment: 'Pago',
    orderconfirmation: 'Confirmación del pedido'
  },
  plan_builder: {
    undo: 'Deshacer',
    item_removed: 'Se eliminó un servicio de su carrito.',
    select_term: '<span class="text-semibold">Seleccione un término</span>  para su suscripción',
    years: 'años',
    apply: 'Solicitar',
    total: 'Total',
    proceed_to_checkout: 'Iniciar compra',
    removed_items: 'El/Los siguiente(s) servicio(s) se ha(n) eliminado de su carrito porque ya tiene(n) una suscripción activa para este(os) producto(s):',
    billing_management: 'Si desea renovarlos, visite la página <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gestión de facturación</a>.',
    open_invoice: 'Tiene una factura abierta para el/los servicio(s) que ya está(n) en su carrito y que se ha(n) eliminado.',
    invoice_link: 'Para pagar estas facturas y reanudar su(s) servicio(s), vaya a <a href="/redirect/mynoip?force=true&intended=account/billing-management" target="_blank">Gestión de facturación</a>.',
    empty_cart: 'Su carrito está vacío',
    purchase_services: 'Consulte todos los servicios que puede adquirir en <a href="/" class="text-info text-decoration-none">No-IP</a>',
    updated_enhanced_item: 'Actualmente tiene <span class="text-semibold">{hostcount} nombres de host</span> y esto supera, <span class="text-semibold">{itemtitle} {itemoptionsquantity} nombre(s) de host</span>. Hemos actualizado su carrito para ir a la próxima suscripción disponible, <span class="text-semibold">{newitemtitle} {newitemoptionsquantity} Hostnames</span>.'
  },
  account: {
    create_an_account: 'Cree una cuenta',
    have_an_account: 'Tiene una cuenta',
    create_account: 'Crear cuenta',
    log_in: 'Iniciar sesión',
    email: 'Email',
    user_password: 'Contraseña',
    tos: "Acepto los <a href='/legal/tos'>Términos de servicio</a> y la <a href='/legal/privacy'>Política de privacidad</a>.",
    newsletter: 'Quiero recibir boletines informativos y ofertas especiales',
    log_in: 'Iniciar sesión',
    email_username: 'Email o nombre de usuario',
    forgotpassword: '¿Olvidó su contraseña?',
    login_continue: 'Iniciar sesión y continuar',
    auth_failure: 'La combinación del nombre de usuario/contraseña es incorrecta. Inténtelo de nuevo.',
    too_many_attempts: 'Se ha enviado el formulario demasiadas veces desde su dirección de IP. Espere unos minutos antes de intentar de nuevo.',
    too_many_attempts: 'Su cuenta fue bloqueada por haber ingresado una contraseña errónea muchas veces. La cuenta se desbloqueará en 15 minutos y podrá intentar iniciar sesión nuevamente. También puede llamar al 1-877-367-6647 durante las horas de atención: de lunes a viernes, de 6:30 a.m. a 5:30 p. m., hora del Pacífico, para desbloquear su cuenta de inmediato. Esta es una función de seguridad para evitar inicios de sesión por la fuerza. Si olvidó su contraseña, use nuestro formulario de olvido de contraseña para recibir un enlace de restablecimiento. Luego, intente iniciar sesión dentro de los 15 minutos.',
    captcha_failure: 'reCAPTCHA incorrecto, deberá completar el reCAPTCHA correctamente para iniciar sesión.',
    newsletter: 'Envíame boletines y ofertas especiales',
    create_account: 'Crear una cuenta',
    logged_in_as: 'Conectado como',
    create_an_account: '¿Necesitas crear una cuenta?',
    already_have_an_account: '¿Ya tienes una cuenta?',
    sign_up_with_google: 'Registrarse con Google',
    sign_in_with_google: 'Iniciar Sesión con Google',
    sign_up_with_microsoft: 'Registrarse con Microsoft',
    sign_in_with_microsoft: 'Iniciar Sesión con Microsoft'
  },
  domain_input: {
    tooltip: 'Ingrese su dominio propio para utilizarlo con este servicio. Nota: Esta acción no registrará el dominio.'
  },
  domain_reg: {
    tooltip: 'Registre su dominio con No-IP, un registrador acreditado por la ICANN.'
  },
  account_enhanced: {
    tooltip: 'Acceda de forma remota a una computadora, un dispositivo o una red sin preocuparse por las confirmaciones mensuales del hostname.',
    hostnames: 'Hostnames'
  },
  support_priority: {
    tooltip: 'Un canal de atención prioritaria que cuenta con nuestro amable y experimentado equipo de asistencia técnica. Su tique o llamada de asistencia estará disponible inmediatamente, para que reciba ayuda cuando más la necesite.'
  },
  dns_tier: {
    tooltip: 'DNS rápido y confiable para su dominio, respaldado por nuestra sólida red Anycast con más de 100 puntos de presencia ubicados en todo el mundo.'
  },
  dns_squared: {
    tooltip: 'Maximice el tiempo de actividad y aumente la confiabilidad utilizando su infraestructura DNS existente.'
  },
  mail_backupmx: {
    tooltip: 'Backup MX le brinda tranquilidad. Si su servidor de correo no funciona, no perderá ningún correo electrónico importante.'
  },
  mail_reflector: {
    tooltip: 'Ejecute su propio servidor de correo incluso si su ISP bloquea el puerto 25'
  },
  mail_pop: {
    tooltip: 'POP3/IMAP es la opción ideal para aquellas personas que no desean administrar su propio servidor de correo electrónico.'
  },
  mail_forwarding: {
    tooltip: 'El reenvío de correo le permite recibir correos con su dominio y reenviarlos a una cuenta existente.'
  },
  mail_smtp: {
    tooltip: 'SMTP es para los administradores que tengan bloqueado el puerto 25 o para los aventureros que no quieran cambiar la configuración de SMTP.'
  },
  ssl_rapid: {
    tooltip: 'Protege un único dominio con un cifrado sólido. Se emite en cuestión de minutos, lo que le ayuda a desarrollar y lanzar un sitio seguro rápidamente.'
  },
  ssl_rapid_dv: {
    tooltip: 'Protege un único dominio con un cifrado sólido. Se emite en cuestión de minutos, lo que le ayuda a desarrollar y lanzar un sitio seguro rápidamente.'
  },
  ssl_premium: {
    tooltip: 'Proporciona procedimientos de autenticación completos (verificación de identidad y nombre de dominio) con una alta garantía, lo que hace que este certificado sea perfecto para proteger su dominio profesional.'
  },
  ssl_rapid_wildcard: {
    tooltip: 'Proteja subdominios ilimitados con un cifrado sólido. Los certificados se emiten en cuestión de minutos y son la forma más rentable de proteger varios dominios.'
  },
  ssl_rapid_wildcard_dv: {
    tooltip: 'Proteja subdominios ilimitados con un cifrado sólido. Los certificados se emiten en cuestión de minutos y son la forma más rentable de proteger varios dominios.'
  },
  ssl_trustcor_standard: {
    tooltip: 'Protege un único hostname con un cifrado sólido. Se emite en cuestión de minutos, lo que le ayuda a desarrollar y lanzar un sitio seguro rápidamente.'
  },
  ssl_trustcor_premium: {
    tooltip: 'Protege un único hostname con un cifrado sólido. Se emite en cuestión de minutos, lo que le ayuda a desarrollar y lanzar un sitio seguro rápidamente.'
  },
  ssl_trustcor_wildcard: {
    tooltip: 'Proteja subdominios ilimitados con un cifrado sólido. Los certificados se emiten en cuestión de minutos y son la forma más rentable de proteger varios dominios.'
  },
  monitor_basic: {
    tooltip: 'Que un servidor esté caído es una cosa, pero no enterarse es aún peor. Reciba una alerta al instante cuando haya un problema.'
  },
  monitor_advanced: {
    tooltip: 'Monitoreo del servidor 24/7, incluyendo el sistema automático de recuperación de fallos. Permita que las configuraciones de DNS se dirijan automáticamente a su servidor de respaldo o a una página personalizada al instante.'
  },
  team_login: {
    tooltip: 'Team Login le permite coordinar sin problemas con diferentes inicios de sesión afiliados a su cuenta.'
  },
  registration_domain: {
    tooltip: 'Registre su dominio con No-IP, un registrador acreditado por la ICANN.',
    bundle_discount: 'Paquete de descuentos',
    you_saved: 'Ha ahorrado',
    hide_info: 'Sí, ocultar mi información personal del mundo durante',
    no_thanks: 'No, gracias',
    private_registration_no: 'Registro privado: No'
  },
  registration_transfer: {
    tooltip: 'Transfiera su dominio de otro registrador a No-IP.'
  },
  registration_privacy: {
    tooltip: 'El registro privado garantiza la privacidad de la información de contacto de su dominio. Instalamos un proxy que se encarga del correo basura y le hace llegar lo que necesita.',
    private_registration: 'Registración Privado'
  },
  host_redemption: {
    tooltip: 'Recupere su hostname de la "Redención" y mantenga la misma configuración que tenía antes de que se produjera la redención.'
  },
  dns_pro: {
    tooltip: 'Cree nombres de host en su propio dominio o use un dominio sin IP con DNS dinámico de grado profesional que se adapte a sus necesidades.'
  },
  domain_contact: {
    contact: {
      oganization: 'Organización',
      email_address: 'Dirección de correo electrónico',
      first_name: 'Nombre',
      last_name: 'Apellido',
      address: 'Dirección',
      address2: 'Dirección 2',
      country: 'País',
      state_province: 'Estado / Provincia',
      city: 'Ciudad',
      postal_zip: 'Código postal',
      phone_number: 'Número de teléfono'
    },
    contact_form: {
      domain_contact: 'Contacto del dominio',
      domain_contact_text: 'Para registrar un dominio es necesario que la información de contacto del mismo sea válida. Esto quiere decir que su nombre y datos de contacto estarán disponibles públicamente en el registro WHOIS. Si ha añadido el registro privado, el registro mostrará nuestra información en lugar de la suya. No se preocupe si le falta algo, nosotros le enviaremos todo lo importante.',
      add_private_reg: 'Añadir registro privado ahora',
      existing_domain_contact: 'Usar un contacto de dominio existente',
      new_domain_conact: 'Crear un nuevo contacto de dominio',
      verifying: 'Verificando',
      continue: 'Continuar',
      an_unexpected_error: "Lo sentimos, se ha producido un error inesperado. Vuelva a intentarlo en unos minutos. Si este error sigue apareciendo, infórmelo en una <a href='/ticket'>solicitud de ayuda</a> con sus datos de contacto."
    },
    order_summary: {
      order_summary: 'Resumen del pedido',
      edit: 'Editar'
    }
  },
  upsell: {
    add_to_cart: 'añadir a la cesta',
    plus_description: 'DNS dinámico totalmente personalizado mediante la creación de un nombre de host fácil de recordar en su propio dominio.',
    enhanced_description: 'Cree un nombre de host fácil de recordar para acceder a su dispositivo de forma remota y nunca se preocupe por confirmar su nombre de host mientras su suscripción permanezca activa.',
    priority_description: 'El soporte prioritario sin IP es un canal de soporte de respuesta prioritaria que cuenta con nuestro amable y experimentado equipo de soporte técnico. El soporte prioritario le permite obtener el soporte que necesita lo más rápido posible.',
    rapid_description: 'Los certificados RapidSSL Basic DV protegen un solo dominio con un cifrado sólido. Se emite en cuestión de minutos, lo que lo ayuda a desarrollar y lanzar un sitio web seguro rápidamente. Es una forma rápida y económica de proteger su sitio web.',
    rapid_wildcard_description: 'Los certificados RapidSSL Wildcard protegen subdominios ilimitados con cifrado sólido. Los certificados se emiten en cuestión de minutos y son la forma más rentable de proteger varios dominios.',
    team_login_description: 'El inicio de sesión del equipo le permite invitar a miembros adicionales del equipo a su cuenta. Permita que los miembros de su equipo lo ayuden a lograr más cosas con la administración de clientes, suscripciones y más.',
    recommended: 'Recomendado',
    team_login_tooltip: 'Cada cuenta de No-IP viene con un propietario de cuenta. ¿Necesitas otro inicio de sesión? Agrega un miembro del equipo a tu cuenta.',
    per_team_member: 'por miembro del equipo'
  }
};
